var CompareTool = (function (window, $) {


  Utility.log('CompareTool.js loaded');

  var compUI;
  var $compWrapper;
  var lastCardOpened;

  var setActiveFeaturesLinks = function (linkHref /* optional */) {
    // Make compare-table section jump-link the active one (first link by
    // default)
    var $featuresLinks = $('.features-links-link', $compWrapper);
    var $selectedFeaturesLink;

    $featuresLinks.removeClass('is-active');

    if (linkHref) {
      $featuresLinks.each(function () {
        // For some reason, attribute-selector doesn't work, so using a loop
        // here
        var $currLink = $(this);

        if ($currLink.prop('href').indexOf(linkHref) !== -1) {
          $currLink.addClass('is-active');
        }
      });
    } else {
      $selectedFeaturesLink = $('.features-links-link:first-child',
        $compWrapper);

      $selectedFeaturesLink.addClass('is-active');
    }
  };

  var modifyFeaturesLinks = function () {
    // put the last two visible links into a wrapper div
    //  so that they wrap onto a new line together - preventing widow links
    var $container = $('features-links .compare-content');

    $container.find('div').remove();

    $container.each(function () {
      var $links = $('a:not(.no-advantage-flag)', $(this));
      var len = $links.length;

      $($links[len - 3]).after('<div class="line-break"></div>');
      $(this).children('div').append($($links[len - 2]), $($links[len - 1]));
    });
  };

  var prependAddVehicleArrowhead = function ($avForm) {
    // Injects arrowhead into add-vehicle section.
    var $arrowhead = $('<div class="add-vehicle-arrowhead"></div>');

    $arrowhead.prependTo($avForm);
  };

  var positionFormArrowhead = function ($clickedCardSlot) {
    // Sets left position of add-vehicle form's arrowhead.
    var screenWidth = document.body.clientWidth;
    var $vehicleSelector = $clickedCardSlot.closest('.vehicle-selector');
    var $cardsSlotsCntr = $('.selector-cards', $vehicleSelector);
    var $formArrowhead = $('#addVehicle .add-vehicle-arrowhead', $compWrapper);
    var vehSelMaxWidth = parseInt($vehicleSelector.css('max-width'), 10);
    var cntrLeftMargin = screenWidth > vehSelMaxWidth
      ? (screenWidth - vehSelMaxWidth) / 2
      : 0;
    var cntrLeftPadding = parseInt($cardsSlotsCntr.css('padding-left'), 10);
    var cntrWidth = screenWidth - ((cntrLeftMargin + cntrLeftPadding) * 2);
    var prevCards = $clickedCardSlot.prevAll('vehicle-card').length;
    var cardsVisible = $('vehicle-card:visible', $cardsSlotsCntr).length;
    var slotsVisible = $('.compare-empty-slot:visible', $cardsSlotsCntr).length;
    var cardsSlotsVisibleTotal = cardsVisible + slotsVisible;
    var cardSlotCntrFactor = (prevCards + 0.5) / cardsSlotsVisibleTotal;
    var posX = Math.round(
      cntrLeftPadding
      + (cntrWidth * cardSlotCntrFactor)
      - ($formArrowhead.outerWidth() / 2),
    );

    $formArrowhead.css('left', posX + 'px');
  };

  var attachChangeVehicleListener = function (ctaSelector) {
    $(document).on('click', ctaSelector, function (evt) {
      var $clickedCard = $(evt.originalEvent.target).closest('vehicle-card');
      var $refineVehicles;

      positionFormArrowhead($clickedCard);
      $refineVehicles = $('#addVehicle .refine-vehicles', $compWrapper);

      if ($clickedCard.prev('vehicle-card').length === 0) {
        $refineVehicles.addClass('refine-anchor');
      } else {
        $refineVehicles.removeClass('refine-anchor');
      }
    });
  };

  var attachAddVehicleListener = function (ctaSelector) {
    $(document).on('click', ctaSelector, function (evt) {
      var $clickedSlot = $(evt.originalEvent.target)
        .closest('.compare-empty-slot');

      positionFormArrowhead($clickedSlot);

      $('#addVehicle .refine-vehicles', $compWrapper)
        .removeClass('refine-anchor');
    });
  };

  var attachCustomDropdownListener = function ($customDropdownCntr) {
    // When User changes Year/Model (by clicking custom-dropdown list-item),
    // clear subsequent dropdown-customizations except one immediately following
    var $customOptions = $customDropdownCntr.find('.acr-select-box-options li');

    $customOptions.on('click', function (e) {
      var $customOption = $(e.target);
      var $customDropdownCntr = $customOption.closest('.acr-select-box-cloned');
      var dataId = $customDropdownCntr.data('id');
      var nativeSelectorPrefix = '.add-vehicle-select#';

      if (dataId === 'year') {
        clearDropdownCustomizations(
          $(nativeSelectorPrefix + 'model, '
            + nativeSelectorPrefix + 'trim', $compWrapper),
        );
      } else if (dataId === 'make') {
        clearDropdownCustomizations($(nativeSelectorPrefix + 'trim'),
          $compWrapper);
      }
    });
  };

  var updateCustomDropdownSelection = function ($nativeSelect) {
    // Replicate any gray-tool dynamic* native-dropdown selection to
    // custom-dropdown.
    // *Gray-tool makes native-dropdown selections dynamically after AJAX
    // responses
    var nativeSelectedIdx = $nativeSelect.prop('selectedIndex');
    var $customOptionsList = $nativeSelect.next('.acr-select-box-cloned')
      .find('.acr-select-box-options ul');
    var $customOptionToSelect;

    if ($customOptionsList.length === 1) {
      $customOptionToSelect = $customOptionsList
        .find('li:eq(' + nativeSelectedIdx + ')');

      if (!$customOptionToSelect.hasClass('selected')) {
        SelectBox.selectOption(
          $customOptionsList.closest('.acr-select-box'),
          $customOptionsList.closest('.acr-select-box-options'),
          $customOptionToSelect.find('span'),
          false,
        );
      }
    }
  };

  var clearDropdownCustomizations = function ($nativeSelects) {
    $nativeSelects.each(function () {
      var $currSelect = $(this);
      var $currClone = $currSelect.next('.acr-select-box-cloned');

      if ($currClone.length > 0) {
        $currSelect.next('.acr-select-box-cloned').remove();
        $currSelect
          .closest('.add-vehicle-select-container').removeClass('cloned');
      }

      $currSelect.show();
    });
  };

  var manageRefineVehicleDropdowns = function () {
    var $selects = $('.refine-vehicles .add-vehicle-select');
    var cloneSelector = '.acr-select-box-cloned';

    var dropdownTimeouts = {
      inserts: {
        year: null,
        make: null,
        model: null,
        trim: null,
      },
      removes: {
        year: null,
        make: null,
        model: null,
        trim: null,
      },
    };

    $selects.each(function (idx, ele) {
      var $currSelect = $(ele);
      var $currSelectCntr = $currSelect
        .closest('.add-vehicle-select-container');
      var currId;
      var currInsertTimeout;

      clearDropdownCustomizations($currSelect);

      // Get/insert id.
      if (ele.id) {
        currId = ele.id;
      } else {
        currId = $currSelect.attr('name');
        $currSelect.attr('id', currId);
      }

      // Customize after options have been dynamically inserted into original
      // select
      currInsertTimeout = dropdownTimeouts.inserts[currId];

      $currSelect.on('DOMNodeInserted', function () {
        if ($currSelect.find('option').length >= 2) {
          if (currInsertTimeout) {
            clearTimeout(currInsertTimeout);
          }

          currInsertTimeout = setTimeout(function () {
            SelectBox.createSelect('.refine-vehicles select#' + currId);
            $currSelectCntr.addClass('cloned');
            $(cloneSelector + ' + ' + cloneSelector, $currSelectCntr).remove();
            setTimeout(function () {
              if ($currSelect.is(':disabled')) {
                clearDropdownCustomizations($currSelect);
              } else {
                // Handle any gray-tool dynamic native-select changes (not made
                // by User).
                updateCustomDropdownSelection($currSelect);
                // Handle clearing/disabling custom-dropdowns after
                // User makes custom-dropdown year/make selection.
                if (currId === 'year' || currId === 'make') {
                  attachCustomDropdownListener($(cloneSelector
                      + '[data-id=' + currId + ']'));
                }
              }
            }, 250);
          }, 100);
        }
      });
    });
  };

  var featureLinksJumpCheckFix = function (e) {
    // checks Features Jump (to Compare-table section) is accurate, after
    // Gray-tool jump code finishes, then
    // fixes scroll position and link-highlight as needed.
    var $link = $(e.originalEvent.target);
    var linkHref = $link.attr('href');
    var sectionId = linkHref.substring(1);

    function checkFixJump(sectionId) {
      var $stickyHeader = $('sticky-header', $compWrapper);
      var stickyHeaderBottom = $stickyHeader.offset().top
          + $stickyHeader.height();
      var sectionTop = $('.features-summary-title#' + sectionId).offset().top;
      var scrollDelta = sectionTop - stickyHeaderBottom;

      if (scrollDelta !== 0) {
        window.scrollBy(0, scrollDelta);
      }
    }

    setTimeout(function () {
      checkFixJump(sectionId);
    }, 750);

    setTimeout(function () {
      setActiveFeaturesLinks(linkHref);
    }, 1000);
  };

  var dupFeatureLinksShowHide = Utility.debounce(function () {
    // shows/hides duplicate features jump-links after page-scroll.
    var $stickyHeader = $('sticky-header', $compWrapper);
    var $duplicateFeaturesLinksCntr = $('.compare-details > features-links',
      $compWrapper);
    var stickyHeaderVisible = $stickyHeader.hasClass('is-visible');

    if (stickyHeaderVisible) {
      $duplicateFeaturesLinksCntr.hide();
    } else {
      $duplicateFeaturesLinksCntr.show();
    }
  }, 50);

  var setListeners = function () {
    // this functions as a ready event for the tool
    compUI.bus.one(compUI.bus.EVENTS.VEHICLES.LOADED, function () {
      setActiveFeaturesLinks();
    });

    compUI.bus.on(compUI.bus.EVENTS.VEHICLES.LOADED, function () {
      var $stickyHeader = $('sticky-header[empty-slots]');
      var $compareWrapper = $('compare-wrapper');

      modifyFeaturesLinks();

      if ($stickyHeader.length > 0) {
        if ($compareWrapper.length > 0) {
          $compareWrapper.attr('empty-slots',
            $stickyHeader.attr('empty-slots'));
        }
      }
    });

    $(document).on('click', '.features-links-link', featureLinksJumpCheckFix);

    $(window).on('scroll', dupFeatureLinksShowHide);

    $(document).on('click', '.icon-close', function () {
      $('vehicle-card').removeClass('faded not-faded');
    });

    attachAddVehicleListener('.compare-empty-slot button');

    attachChangeVehicleListener('vehicle-card .change-button');

    compUI.bus.on(compUI.bus.EVENTS.VEHICLES.SHOW_ADD_VEHICLE, function (data) {
      manageRefineVehicleDropdowns();

      shadeUnselectedVehicleCards(data.change);
    });
  };

  var shadeUnselectedVehicleCards = function (id) {
    // check if user is closing the same card they just opened
    // prevents issue AR-14032
    if (lastCardOpened !== id) {
      $('.vehicle-card-content:not([vehicle-id="' + id + '"])')
        .closest('vehicle-card').addClass('faded')
        .removeClass('not-faded');

      $('.vehicle-card-content[vehicle-id="' + id + '"]')
        .closest('vehicle-card').removeClass('faded')
        .addClass('not-faded');

      lastCardOpened = id;
    } else {
      $('.vehicle-card-content').closest('vehicle-card').removeClass('faded')
        .addClass('not-faded');

      lastCardOpened = null;
    }
  };

  var init = function () {
    var sitecoreExpEditor = !!(window.Sitecore
        && window.Sitecore.WebEditSettings
        && window.Sitecore.WebEditSettings.editing);
    var $compareWrapper = $('compare-wrapper');

    if ($compareWrapper.length > 0 && !sitecoreExpEditor) {
      compUI = window.platform.compare.init();
      prependAddVehicleArrowhead($('form#addVehicle', $compareWrapper));
      setListeners();
    }
  };

  return {
    init: init,
  };
}(window, $));
